<template>
    <content-loader :height="200" preserveAspectRatio="none">
      <rect x="0" y="0" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="30" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="60" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="90" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="120" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="150" rx="4" ry="4" width="390" height="25" />
      <rect x="0" y="180" rx="4" ry="4" width="390" height="25" />
    </content-loader>
  </template>

  <script>
  import { ContentLoader } from 'vue-content-loader'

  export default {
    name: "video-loading-skeleton",
    components: { ContentLoader }
  }
  </script>

  <style scoped>
  </style>